import { Typography } from '@mui/material'

import { TOfuSimulateMessage } from '~/features/campaigns/models'
import BaseChatBubble from '~/features/inbox/components/chatSection/baseChatBubble'
import { ESpeaker } from '~/features/inbox/models'

type TOFUSimulateStepConversationItemProps = {
  message: TOfuSimulateMessage
}

export default function OFUSimulateStepConversationItem({
  message,
}: TOFUSimulateStepConversationItemProps) {
  return (
    <BaseChatBubble
      name={message.role}
      activityDate={message.date || ''}
      speaker={message.role as ESpeaker}
    >
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
        {message.content}
      </Typography>
    </BaseChatBubble>
  )
}
